<script>
  import { fade } from 'svelte/transition'
  import { snackBarStore } from '../state/store'
  import Icon from './Icon.svelte'
  import { t } from '../i18n/i18n'

  $: selfDestruct = $snackBarStore.selfDestruct

  let timeLeft = ''
  let interval
  $: if (selfDestruct) {
    let timer = Number.isInteger(selfDestruct) ? selfDestruct : 5
    timeLeft = timer
    interval = setInterval(() => {
      timer = timer - 1
      if (timer > 0) {
        timeLeft = timer
      } else {
        clearInterval(interval)
        snackBarStore.set({})
      }
    }, 1000);
  }

  let stopDestruct = () => {
    clearInterval(interval)
    timeLeft = ''
  }

</script>

<style>

  section {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    color: var(--grey);
    background: var(--white);
    font-size: 2rem;
    padding: 1.4rem;
    border-radius: .6rem;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3);
    border: 2px solid;
    display: flex;
    align-items: center;
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);
    width: min(60rem, 100% - 1rem);
  }

  .error {
    border-color: var(--red);
  }
  
  .info {
    border-color: var(--light-blue);
  }

  .warning {
    border-color: var(--orange);
  }

  .success {
    border-color: var(--green);
  }

  .type {
    display: inline-block;
    margin-right: 1.2rem;
    text-transform: capitalize;
    font-weight: bold;
    align-self: flex-start;
  }

  p {
    flex: 1;
  }

  button {
    background: transparent;
    border: none;
    text-transform: uppercase;
  }

  button:hover {
    cursor: pointer;
  }
  
</style>

{#if $snackBarStore.message}
  <section class={$snackBarStore.type} transition:fade|global={{duration: 400}} on:mouseover={stopDestruct}>
    <span class="type"><Icon name={$snackBarStore.type} viewSize=16 /> </span>
    <p>{$t[$snackBarStore.message]}</p>
    <button on:click={() => snackBarStore.set({})}>{$t.close} {timeLeft ? `(${timeLeft})` : '' }</button>
  </section>
{/if}
